<div class="row-with-button">
    <div class="text-block">
        {{ primaryText }}
        <div class="secondary">
            {{ secondaryText }}
        </div>
    </div>
    <button mat-stroked-button (click)="handleClick()">{{ buttonLabel }}</button>
</div>
